import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { useEffect } from "react";
import {
  Container,
  RadioGroup,
  Typography,
  TextField,
  Button,
  Radio,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  name: yup.string("Enter your name").required("A name is required"),
  phone_number: yup
    .string()
    .required("A phone number is required")
    .matches(phoneRegExp, "Phone number is not valid")
    .min(10, "to short")
    .max(10, "to long"),
  time: yup
    .string("When is the best time to call?")
    .required("A time is required"),
  caseType: yup.string().required("Answer is Required"),
  description: yup
    .string("Describe your case")
    .min(100, "Please use at least 100 characters")
    .max(500, "Please limit response to 500 characters")
    .required("A brief description is required"),
});

export default function MediationForm({ handleClose, setRequestSubmitted }) {
  useEffect(() => {}, [setRequestSubmitted]);
  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      phone_number: "",
      time: "",
      caseType: "",
      description: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const hostData = {
        service_id: "service_2d24n9e",
        template_id: "template_n8tm2yg",
        user_id: "yHdFYUBkv_jGfIl9_",
        template_params: {
          consultation_type: "Mediation",
          medicalBills: "N/A",
          recent: "N/A",
          policeReport: "N/A",
          atFault: "N/A",
          previousAttorney: "N/A",
          ...values,
        },
      };

      const clientData = {
        service_id: "service_2d24n9e",
        template_id: "template_5zwgzz5",
        user_id: "yHdFYUBkv_jGfIl9_",
        template_params: {
          consultation_type: "Mediation",
          medicalBills: "N/A",
          recent: "N/A",
          policeReport: "N/A",
          atFault: "N/A",
          previousAttorney: "N/A",
          ...values,
        },
      };

      const hostRequestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(hostData),
        contentType: "application/json",
      };

      const clientRequestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(clientData),
        contentType: "application/json",
      };
      await fetch("https://api.emailjs.com/api/v1.0/email/send", hostRequestOptions)
        .then((response) => {
          if (response.ok) {
          } else {
            throw new Error("Something went wrong");
          }
        })
        .catch((error) => {
          console.log(error);
        });
      await fetch("https://api.emailjs.com/api/v1.0/email/send", clientRequestOptions)
        .then((response) => {
          if (response.ok) {
            localStorage.setItem(
              "requestSubmitted",
              moment().format("MMM DD YY")
            );
            setRequestSubmitted(moment());

          } else {
            throw new Error("Something went wrong");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const CHARACTER_LIMIT = 500;

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          autoFocus
          fullWidth
          sx={{ padding: "0px 0px 10px 0px" }}
          id="email"
          name="email"
          label="Email"
          variant="filled"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <TextField
          fullWidth
          sx={{ padding: "0px 0px 10px 0px" }}
          id="name"
          name="name"
          label="Name"
          variant="filled"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />
        <TextField
          fullWidth
          sx={{ padding: "0px 0px 10px 0px" }}
          id="phone_number"
          name="phone_number"
          label="Phone Number"
          variant="filled"
          value={formik.values.phone_number}
          onChange={formik.handleChange}
          error={
            formik.touched.phone_number && Boolean(formik.errors.phone_number)
          }
          helperText={formik.touched.phone_number && formik.errors.phone_number}
        />
        <TextField
          fullWidth
          sx={{ padding: "0px 0px 10px 0px" }}
          id="time"
          name="time"
          label="When is the best time to contact you?"
          variant="filled"
          value={formik.values.time}
          onChange={formik.handleChange}
          error={formik.touched.time && Boolean(formik.errors.time)}
          helperText={formik.touched.time && formik.errors.time}
        />
        <Container>
          <Typography variant="h6" sx={{ padding: "10px 0px" }}>
            What type of case are you seeking to mediate?
          </Typography>
          <FormHelperText sx={{ color: "#D10000" }}>
            {formik.touched.caseType && formik.errors.caseType}
          </FormHelperText>
          <RadioGroup
            name="caseType"
            label="Case Type"
            row
            value={formik.values.caseType}
            onChange={formik.handleChange}
            error={formik.touched.caseType && formik.errors.caseType}
          >
            <FormControlLabel
              value="Personal Injury"
              control={<Radio />}
              label="Personal Injury"
            />
            <FormControlLabel
              value="Intellectual Property"
              control={<Radio />}
              label="Intellectual Property"
            />
            <FormControlLabel
              value="Family Law"
              control={<Radio />}
              label="Family Law"
            />
          </RadioGroup>
        </Container>
        <TextField
          margin="dense"
          type="description"
          helperText={`${formik.values.description.length}/${CHARACTER_LIMIT}`}
          fullWidth
          multiline
          minRows={4}
          variant="filled"
          id="description"
          name="description"
          label="Please Describe Your Case"
          value={formik.values.description}
          onChange={formik.handleChange}
          error={
            formik.touched.description && Boolean(formik.errors.description)
          }
        />
        <FormHelperText sx={{ color: "#D10000" }}>
          {formik.touched.description && formik.errors.description}
        </FormHelperText>
        <Container sx={{ display: "flex", justifyContent: "space-evenly" }}>
          <Button color="primary" variant="contained" type="submit">
            Submit
          </Button>
          <Button color="primary" variant="contained" onClick={handleClose}>
            Cancel
          </Button>
        </Container>
      </form>
    </div>
  );
}
